import React from 'react';

/**
 * Format error codes to user-friendly messages
 * Converts SNAKE_CASE error codes to Title Case
 * @param errorCode - Raw error code (e.g., "TICKET_NOT_FOUND")
 * @returns Formatted message (e.g., "Ticket Not Found")
 */
export const formatErrorMessage = (errorCode: string): string => {
  if (!errorCode) return errorCode;

  // Convert SNAKE_CASE to Title Case
  return errorCode
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const signUpEmailFieldErrorMessage = (errors: any) => {
  if (errors?.email?.message) {
    return errors?.email?.message;
  }
  if (errors?.email?.type === 'pattern') {
    return 'Please enter a valid email address';
  }
  return 'Please enter an email address';
};

export const signUpEmailDomainErrorMessage = (errors: any) => {
  if (errors.register.name === 'UserLambdaValidationException') {
    return 'Please enter your corporate/work email address.';
  }
  if (errors.register.name === 'UsernameExistsException') {
    return (
      <span>
        An account with the given email already exists.{' '}
        <a
          href="/auth/login"
          style={{
            color: '#d32f2f',
            width: 'fit-content',
            borderBottomStyle: 'solid',
          }}
        >
          Sign in
        </a>{' '}
        instead.
      </span>
    );
  }
  return errors.register.message;
};
